<template>
	<div>
		<el-table :data="list" border size="mini">
			<el-table-column prop="create_time" align="center" :label="$t('virtual.create_time')" data-nam="申请时间">
				<template slot-scope="scope"> {{getTime_us(scope.row.create_time,'mmddyyyy')}} {{getTime_us(scope.row.create_time,'hh:ii')}} </template>
			</el-table-column>
			<el-table-column prop="class_date_time" align="center" :label="$t('virtual.leave_time')" data-nam="请假时间">
				<template slot-scope="scope"> {{getTime_us(scope.row.class_date_time,'mmddyyyy')}} {{getTime_us(scope.row.class_date_time,'hh:ii')}} </template>
			</el-table-column>
			<el-table-column prop="name" align="center" :label="$t('virtual.feedback_name')" data-name="用户"></el-table-column>
			<el-table-column prop="reason" align="center" :label="$t('virtual.reason')" data-name="理由"></el-table-column>
			<el-table-column prop="status" align="center" :label="$t('virtual.status')" data-name="状态">
				<template slot-scope="{row}">
					<div v-if="row.status==1">{{lang=='cn'?'申请中':'Application in progress'}}</div>
					<div v-if="row.status==2">{{lang=='cn'?'已拒绝':'Rejected'}}</div>
					<div v-if="row.status==3">{{lang=='cn'?'已批准':'Approved'}} 
						<span v-if="row.user_coupon_ids">({{lang=='cn'?'已发优惠券':'Issued Coupon'}})</span>
						<span v-if="row.change_course_id">({{lang=='cn'?'已补课':'Supplementary classes have been taken'}})</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="new_teacher_name" align="center" :label="$t('virtual.teacher')" data-name="老师" v-if="user_type=='teacher'"></el-table-column>
			<el-table-column prop="remarks" align="center" :label="$t('virtual.remarks')" data-name="备注" v-if="user_type=='user'">
				<template slot-scope="scope">
					{{getTime_us(scope.row.remarks_show_time,'mmddyyyy')}}
					<br>
					{{scope.row.remarks}}
				</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right">
				<template slot-scope="scope">
					<div v-if="scope.row.status=='1'">
						<el-button size="mini" type="primary" @click="LeaveAction(scope.row,'3')" data-name="通过">{{$t('virtual.adopt')}}</el-button>
						<el-button size="mini" type="primary" @click="LeaveAction(scope.row,'2')" data-name="驳回">{{$t('virtual.reject')}}</el-button>
					</div>
					<div v-if="scope.row.status=='3'&&user_type=='teacher'">
						<el-button size="mini" type="primary" @click="huanlaoshi_f(scope.row,'3')" data-name="换老师">{{$t('virtual.change_teacher')}}</el-button>
					</div>
					<div v-if="scope.row.status=='3'&&user_type=='user'">
						<el-button size="mini" type="primary" v-if="!scope.row.change_course_id" @click="change_courses_add(scope.row)" data-name="换课">{{$t('virtual.change_course')}}</el-button>
						<el-button size="mini" type="primary" v-if="!scope.row.user_coupon_ids" @click="adminLeaveSendCouponAction(scope.row)" data-name="补发优惠券">补发优惠券</el-button>
						<el-button size="mini" type="primary" @click="del(scope.row)" data-name="删除">{{$t('index.del')}}</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
		</div>
		<el-dialog :title="$t('virtual.change_teacher')" width="400px" :close-on-click-modal="false" :append-to-body="true" :visible="change_teacher_is" @close="change_teacher_is = false">
			<el-form :model="editForm" size="mini" label-position="top" :rules="editFormRules" ref="editForm">
				<el-col :span="24">
					<el-form-item :label="$t('virtual.change_teacher')" prop="teacher_id">
						<el-select v-model="editForm.teacher_id" class="w100" :placeholder="$t('index.select')" >
							<el-option v-for="(item,index) in teacher_list" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.teacher_id"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="change_teacher_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="changeTeacher('')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="$t('virtual.remarks')" width="400px" :close-on-click-modal="false" :append-to-body="true" :visible="remarks_is" @close="remarks_is = false">
			<el-form :model="editForm" size="mini" label-position="top" :rules="editFormRules" ref="editForm">
				<el-col :span="24">
					<el-form-item :label="$t('virtual.time')" prop="remarks_show_time">
						<el-date-picker v-model="editForm.remarks_show_time" type="date" value-format="yyyy-MM-dd" :placeholder="$t('index.select')"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item :label="$t('virtual.remarks')" prop="remarks">
						<el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="$t('index.input')" v-model="editForm.remarks"></el-input>
					</el-form-item>
				</el-col>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="huife = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="bezhutianj('')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="$t('virtual.change_course')" width="1200px" :close-on-click-modal="false" :append-to-body="true" :visible="change_courses_is" @close="change_courses_is = false">
			<change_courses :select="1" @callback="callback_change_courses" v-if="change_courses_list_is"></change_courses>
			<div v-if="!change_courses_list_is">
				<el-form :model="change_courses_data" size="mini" label-position="top" :rules="editFormRules" ref="change_courses_data">
					<el-col :span="24">
						<el-form-item :label="$t('course_index.theme')" prop="theme">
							<el-input :value="lang=='cn'?change_courses_data.theme_cn:change_courses_data.theme" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item :label="$t('course_index.time')" prop="trip_course_id">
							<el-radio-group v-model="change_courses_data.trip_course_id">
								<el-radio :label="item.id" style="padding:10px 0;" v-for="(item,index) in change_courses_data.tripcourse" :key="index">{{getTime_us(item.class_date_time,'mmddyyyy')}}  {{getTime_us(item.class_date_time,'hh:ii')}}</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer" v-if="!change_courses_list_is">
				<el-button size="mini" @click.native="change_courses_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="change_courses_data_post('')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import change_courses from '@/components/change_courses'
export default {
	components: {
		change_courses
	},
	computed: {
		editFormRules() {
			return {
				teacher_id: [{
					required: true,
					message: this.$t('index.select') + this.$t('virtual.change_teacher'),
					trigger: 'change'
				}],
				trip_course_id: [{
					required: true,
					message: this.$t('index.select') + this.$t('course_index.time'),
					trigger: 'change'
				}],
				remarks: [{
					required: true,
					message: this.$t('index.input') + this.$t('virtual.remarks'),
					trigger: 'blur'
				}],
				remarks_show_time: [{
					required: true,
					message: this.$t('index.select') + this.$t('virtual.time'),
					trigger: 'change'
				}],
			}
		},
	},
	props:{
		type: {
			type: String,
			default:''
		},
		course_id: {
			type: String,
			default:''
		},
		course_type: {
			type: String,
			default:''
		},
		user_type: {
			type: String,
			default:''
		},
	},
	data() {
		return {
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
			teacher_list:[],
			list:[],
			change_teacher_is:false,
			remarks_is:false,
			editForm:{
				teacher_id:'',
				trip_id:'',
				id:'',
				remarks:'',
				remarks_show_time:'',
			},
			change_courses_is:false,
			change_courses_list_is:false,
			change_courses_data:{
				trip_course_id:'',
				id:'',
				course_id:'',
				tripcourse:[],
				theme_cn:'',
				theme:'',
			},
		}
	},
	watch: {
		type(v){
			if (v=='teacher_leave'||v=='student_leave') {
				this.init();
			}
		},
	},
	// 初始事件
	mounted: function () {
		this.config();
	},
	// 事件
	methods: {
		// 获取老师列表
		config() {
			var this_ = this;
			var url = "courseScreen";
			this_.$post(url, {}).then((res) => {
				this_.teacher_list=res.teacher;
			})
		},
		// 初始化请假列表
		init(){
			var this_ = this;
			var url = "userLeaveList";
			var datas = {
				course_id:this_.course_id,
				course_type: this_.course_type,
				user_type:this_.user_type,
				page: this_.pages.page,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		// 请假审批同意3 或拒绝2
		LeaveAction(data,status){
			var this_ = this;
			var url = "adminLeaveAction";
			var datas = {
				id:data.id,
				status:status,
			};
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.operation_success'));
				this_.init();
			})
		},
		// 换老师
		huanlaoshi_f(data){
			this.editForm.trip_id=data.trip_id;
			this.change_teacher_is=true;
		},
		// 换老师
		changeTeacher(){
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var url = "changeTeacher";
					var datas = {
						trip_id:this_.editForm.trip_id,
						teacher_id:this_.editForm.teacher_id,
					};
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.change_teacher_is=false;
						this_.init();
					})
				}
			})
		},
		// 换课
		remarks_f(data){
			this.editForm={
				id:data.id,
				remarks:'',
				remarks_show_time:'',
			}
			this.remarks_is=true;
		},
		bezhutianj(){
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var url = "addLeaveRemarks";
					var time=this_.editForm.remarks_show_time.split('-');
					var date=Math.round(new Date(time[0],(time[1]-1),time[2],23,59,59).getTime()/1000);
					var datas = {
						id:this_.editForm.id,
						remarks:this_.editForm.remarks,
						remarks_show_time:date,
					};
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.operation_success'));
						this_.remarks_is=false;
						this_.init();
					})
				}
			})
		},
		guanbi(){
			this.$emit("guanbitanchu");
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		status_f(w,s,d){
			var status_cn=['','申请中','已拒绝','已批准'];
			var status_en=['','Application in progress','Rejected','Approved'];
			console.log(this.lang)
			var zhi= this.lang=='cn'?status_cn[d]:status_en[d];
			return zhi;
		},
		adminLeaveSendCouponAction(data){
			var url = "adminLeaveSendCouponAction";
			this.$post(url, {id:data.id}).then((res) => {
				this.$message.success(this.$t('index.operation_success'));
				this.init();
			})
		},
		del(data){
			var this_ = this;
			var url = "deleteLeave";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		change_courses_add(data){
			this.change_courses_data = {
				trip_course_id:'',
				id:data.id,
				course_id:'',
				tripcourse:[],
				theme_cn:'',
				theme:'',
			};
			this.change_courses_is=true;
			this.change_courses_list_is=true;
		},
		callback_change_courses(data){
			this.change_courses_data.course_id = data.id;
			this.change_courses_data.theme_cn = data.theme_cn;
			this.change_courses_data.theme = data.theme;
			var datas={
				id:this.change_courses_data.id,
				course_id:this.change_courses_data.course_id,
			}
			this.$post('getTripCourse', datas).then((res) => {
				this.change_courses_data.tripcourse = res;
				this.change_courses_list_is=false;
			})
		},
		change_courses_data_post(){
			this.$refs.change_courses_data.validate((valid) => {
				if (valid) {
					var datas = {
						id:this.change_courses_data.id,
						course_id:this.change_courses_data.course_id,
						trip_course_id:this.change_courses_data.trip_course_id,
					};
					this.$post('changeTripCourse', datas).then((res) => {
						this.$message.success(this.$t('index.operation_success'));
						this.init();
						this.change_courses_is=false;
						this.change_courses_list_is=false;
					})
				}
			})
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.page-pagination{
	padding: 20px 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/leave.vue